import {BaseApi} from '../shared/base-api';

export interface ICheckLoginMethodRequest
{
	email: string;
}

export interface ICheckLoginMethodResponse
{
	method: 'email' | 'password';
}

export interface ISubmitPasswordRequest
{
	email: string;
	password: string;
}

export interface ISubmitPasswordResponse
{
}

export interface IForgotPasswordRequest
{
	email: string;
}

export interface IForgotPasswordResponse
{
}

export interface ISendVerificationEmailRequest
{
	email: string;
}

export interface ISendVerificationEmailResponse
{
}

export class Api
{
	public static CheckLoginMethod (body: ICheckLoginMethodRequest): Promise<ICheckLoginMethodResponse>
	{
		return BaseApi.Post('/api/login/check_method', body);
	}

	public static SubmitPassword (body: ISubmitPasswordRequest): Promise<ISubmitPasswordResponse>
	{
		return BaseApi.Post('/api/login/submit_password', body);
	}

	public static ForgotPassword (body: IForgotPasswordRequest): Promise<IForgotPasswordResponse>
	{
		return BaseApi.Post('/api/login/forgot_password', body);
	}

	public static SendLoginEmail (body: ISendVerificationEmailRequest): Promise<ISendVerificationEmailResponse>
	{
		return BaseApi.Post('/api/login/verification_email', body);
	}
}
